/**
 * Judge.me 评论图片灯箱关闭时的滚动位置恢复修复。
 *
 * Judge.me 灯箱（Magnific Popup，body.jm-mfp-is-open）打开时用
 * position:fixed + 负 top 锁定页面滚动；关闭时在释放锁定的同一时刻移除
 * 遮罩层，约一帧之后才调用 window.scrollTo 恢复原位置——期间浏览器会把
 * "页面顶部"绘制出来，用户感知为闪一下；主题 html { scroll-behavior:
 * smooth } 还会把恢复变成可见的滚动动画。
 *
 * 本模块在灯箱打开时从 body.style.top 记下锁定位置，并用 MutationObserver
 * 监听 body 的 class/style 变化；一旦检测到灯箱关闭（类被移除或锁定被
 * 释放），立即在同一微任务内以 auto 行为瞬时恢复滚动位置——微任务先于
 * 绘制执行，"页面顶部"的帧永远不会被绘制。随后在短时间内保持
 * scroll-behavior:auto 以覆盖灯箱自身的延迟恢复，最后还原设置，不影响
 * 站内其他平滑滚动。
 */
(function () {
  'use strict';

  var RESTORE_WINDOW_MS = 400;
  var timer = null;
  var savedY = null;
  var wasOpen = false;

  function readLockedY() {
    var top = parseInt(document.body.style.top, 10);
    return isNaN(top) ? 0 : -top;
  }

  function restoreNow() {
    if (savedY == null) {
      return;
    }
    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo(0, savedY);
    clearTimeout(timer);
    timer = setTimeout(function () {
      document.documentElement.style.scrollBehavior = '';
      savedY = null;
    }, RESTORE_WINDOW_MS);
  }

  function check() {
    var body = document.body;
    var isOpen = body.classList.contains('jm-mfp-is-open');
    if (isOpen && body.style.position === 'fixed') {
      savedY = readLockedY();
      wasOpen = true;
      return;
    }
    if (wasOpen && (!isOpen || body.style.position !== 'fixed')) {
      restoreNow();
      wasOpen = false;
    }
  }

  function start() {
    new MutationObserver(check).observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style'],
    });
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();
